import { useSyncExternalStore } from "react";

export type Theme = "system" | "light" | "dark";
const listeners = new Set<() => void>();

const read = (): Theme => {
  try {
    const t = localStorage.getItem("theme");
    return t === "light" || t === "dark" ? t : "system";
  } catch {
    return "system";
  }
};

export function setTheme(theme: Theme) {
  try {
    theme === "system" ? localStorage.removeItem("theme") : localStorage.setItem("theme", theme);
  } catch {}
  if (theme === "system") delete document.documentElement.dataset.theme;
  else document.documentElement.dataset.theme = theme;
  for (const fn of listeners) fn();
}

export const cycleTheme = () => setTheme(({ system: "light", light: "dark", dark: "system" } as const)[read()]);

export function useTheme(): Theme {
  return useSyncExternalStore((fn) => {
    listeners.add(fn);
    return () => listeners.delete(fn);
  }, read);
}
